import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./helpCenter.html";
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { selectHelpCenter, WireI18n } from '~/modules/stores/i18nStore';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';
import { getUniqueIteratorKey } from '~/modules/utilities/lwcUtilities';
const NEWS_ITEMS = ['agentExchangeSolutions'];
const JAPANESE_NEWS = ['globalNav', 'explore'];
class HelpCenter extends LightningElement {
  constructor(...args) {
    super(...args);
    this.isLoggedIn = false;
    this.showPopover = false;
    this.labels = void 0;
  }
  get helpCenterClass() {
    return 'help-center ' + (this.isLoggedIn ? 'logged-in' : 'not-logged-in');
  }
  get openButtonClass() {
    return this.showPopover ? 'open-button popover-open' : 'open-button';
  }
  get handleTooltipButtonRef() {
    return this.template.querySelector('.open-button');
  }
  get news() {
    const newsLabels = this.labels.news;
    return NEWS_ITEMS.reduce((newsItems, newsItem) => {
      newsItems.push({
        title: newsLabels[newsItem]?.title || '',
        text: newsLabels[newsItem]?.text || '',
        iteratorKey: getUniqueIteratorKey()
      });
      return newsItems;
    }, []);
  }
  get jpNews() {
    const jpNewsLabels = this.labels.news;
    return JAPANESE_NEWS.map(jpNewsItem => ({
      title: jpNewsLabels[jpNewsItem]?.title || '',
      text: jpNewsLabels[jpNewsItem]?.text || '',
      iteratorKey: getUniqueIteratorKey()
    }));
  }
  get isJapaneseUserLanguage() {
    return getUserLanguage() === JAPANESE_LANGUAGE_CODE;
  }
  togglePopover() {
    if (this.showPopover === false) {
      this.openPopover();
    } else {
      this.closePopover();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleEscapeKey(event) {
    if (event.key === 'Escape') {
      this.closePopover();
      event.preventDefault();
      event.stopPropagation();
    }
  }
  handleTooltipButtonFocus() {
    this.handleTooltipButtonRef?.focus();
  }
  closePopover() {
    this.showPopover = false;
    this.handleTooltipButtonFocus();
  }
  openPopover() {
    this.showPopover = true;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(HelpCenter, {
  publicProps: {
    isLoggedIn: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectHelpCenter
        };
      }
    }
  },
  fields: ["showPopover"]
});
const __lwc_component_class_internal = _registerComponent(HelpCenter, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;